"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
} from "../../../../../../public/images/blogs/floorPlanKitchen";

export default function BlogContent() {
  const t = useTranslations("blogs.floorPlanKitchen");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/neubauprojekt">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/aufmass-service-vor-ort">{chunks}</BlogLink>
            ),
            ul: () =>  (
              <ul>
                <li>
                  {t.rich("sections.section3.list.0", {
                    bold: (chunks) => <strong>{chunks}</strong>
                  })}
                </li>
                <li>
                  {t.rich("sections.section3.list.1", {
                    bold: (chunks) => <strong>{chunks}</strong>
                  })}
                </li>
                <li>{t("sections.section3.list.2")}</li>
                <li>{t("sections.section3.list.3")}</li>
                <li>
                  {t.rich("sections.section3.list.4", {
                    bold: (chunks) => <strong>{chunks}</strong>
                  })}
                </li>
                <li>
                  {t.rich("sections.section3.list.5", {
                    bold: (chunks) => <strong>{chunks}</strong>
                  })}
                </li>
              </ul>
            )
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/bemasste-grundrisse">{chunks}</BlogLink>
            ),
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
